import React, { useEffect, useRef, useState } from "react";
import { TextInput, Select } from "../../components/form/inputs";
import { CiCircleInfo } from "react-icons/ci";
import { Tooltip } from "react-tooltip";
import ToggleBtn from "../../components/button/ToggleBtn";
import TimeRangePicker12 from "../../components/ui/TimeRangePicker12";
import PrimaryBtn from "../../components/button/PrimaryBtn";
import UploadTriggerCard from "../../components/upload/UploadTriggerCard";
import uploadIcon from "../../assets/images/svgs/other/uploadImg.svg";
import PhotoLibraryModal from "../../components/Modals/PhotoLibraryModal";
import DecorativeSquares from "../../components/ui/DecorativeSquares";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { getProfileDetail } from "../../redux/thunks/profileThunk";
import { useDispatch, useSelector } from "react-redux";
import UploadIcon from "../../assets/images/svgs/other/Uploadicon.svg";
import GalleryImg from "../../assets/images/svgs/other/uploadImg.svg";
import EditServiceShimmer from "../../components/Preloader/EditServiceShimmer";
import {
  getCurrency,
  getTimeZone,
  addOrUpdateService,
  otherServiceImages,
  getServiceDetails,
} from "../../redux/thunks/serviceRegThunk";
import {
  DndContext,
  closestCenter,
  PointerSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  arrayMove,
  rectSortingStrategy,
} from "@dnd-kit/sortable";
import SortableImageItem from "../../components/upload/SortablleImageItem";
import { FaArrowLeft } from "react-icons/fa";

const EditService = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showLibrary, setShowLibrary] = useState(false);
  const [showUploadOptions, setShowUploadOptions] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [selectedZone, setSelectedZone] = useState("");
  const fileInputRef = useRef(null);
  const initialImagesRef = useRef(null);
  const [isCurrencyEnabled, setIsCurrencyEnabled] = useState(1);
  const [countryId, setCountryId] = useState("");
  const [formErrors, setFormErrors] = useState({});
  const [currencyId, setCurrencyId] = useState("");
  const [timezonedid, setTimezoneid] = useState("");
  const [serviceName, setServiceName] = useState("");
  const [serDescrip, setSerDescrip] = useState("");
  const [toggleValue, setToggleValue] = useState("");
  const [removedImages, setRemovedImages] = useState([]);
  const {
    currencies: currencyFromApi,
    timezones: timeZoneFromApi,
    isServiceLoading,
  } = useSelector((state) => state.setService);
  const [lunchstart, setLunchStart] = useState({
    hour: "",
    minute: "",
    period: "AM",
  });

  const [lunchend, setLunchEnd] = useState({
    hour: "",
    minute: "",
    period: "PM",
  });
  const [dinnerstart, setDinnerStart] = useState({
    hour: "",
    minute: "",
    period: "AM",
  });

  const [dinnerend, setDinnerEnd] = useState({
    hour: "",
    minute: "",
    period: "PM",
  });

  // Get service providers details
  useEffect(() => {
    dispatch(getServiceDetails())
      .unwrap()
      .then((res) => {
        const data = res.data;
        // console.log("The res of data is :", res.data);
        // BASIC INFO
        setServiceName(data.service_name || "");
        setSerDescrip(data.service_description || "");
        setToggleValue(data.is_pure_veg_food ? 1 : 0);

        // CURRENCY & TIMEZONE
        setCurrencyId(data.currency_id);
        setTimezoneid(data.timezone_id);

        // TIMES (24hr → 12hr)
        setLunchStart(convertTo12Hour(data.lunch_time_from));
        setLunchEnd(convertTo12Hour(data.lunch_time_to));
        setDinnerStart(convertTo12Hour(data.dinner_time_from));
        setDinnerEnd(convertTo12Hour(data.dinner_time_to));
        setIsCurrencyEnabled(data.is_currency_and_timezone_enable);
        if (res.data?.service_other_images?.length) {
          const ServiceImgData = res.data.service_other_images.map(
            (img, index) => {
              return {
                id: crypto.randomUUID(),
                type: img.type,
                imageId: img.id,
                name: img.name || img.image_url?.split("/").pop(),
                preview: img.image_url,
                isCover: img.is_cover_image === 1,
                isNew: false,
              };
            },
          );
          const coverIndex = ServiceImgData.findIndex((img) => img.isCover);
          if (coverIndex > 0) {
            const coverImage = ServiceImgData.splice(coverIndex, 1)[0];
            ServiceImgData.unshift(coverImage);
          }

          initialImagesRef.current = ServiceImgData.map((img) => ({
            imageId: img.imageId,
            type: img.type,
          }));
          setServiceImages(ServiceImgData);
        }
      });
  }, [dispatch]);

  // console.log("getServiceDetails called");

  useEffect(() => {
    dispatch(getProfileDetail())
      .unwrap()
      .then((res) => {
        const country_id = res.data?.country_id;
        // console.log("The country id is :", country_id);
        // setCountryId(country_id);
      })
      .catch((err) => {
        // console.log("Profile fetch error:", err);
      });
  }, [dispatch]);

  // Fetch currency & timezone AFTER countryId is available
  useEffect(() => {
    dispatch(getCurrency())
      .unwrap()
      .then((res) => {
        // console.log("The currecy response is :", res.data);
        const currencyData = res.data;
        const currency = currencyData.map((cur) => {
          return {
            id: cur.id,
            countryid: cur.country_id,
          };
        });
      });
  }, [dispatch]);
  useEffect(() => {
    if (!countryId) return;

    dispatch(getTimeZone({ country_id: countryId }))
      .unwrap()
      .then((res) => {
        if (!res.data?.length) return;

        // If timezoneId already exists (from service details), match it
        if (timezonedid) {
          const matchedZone = res.data.find((zone) => zone.id === timezonedid);

          if (matchedZone) {
            setSelectedZone(matchedZone.name);
          }
        }
      });
  }, [dispatch, countryId]); // ✅ run only when countryId is available

  const currencies = currencyFromApi?.map((cu) => {
    return {
      id: cu.id,
      value: cu.country_name,
      label: `${cu.country_name} (${cu.currency_code}) (${cu.currency_symbol})`,
    };
  });
 
  const timezones = timeZoneFromApi?.map((time) => {
    return {
      id: time.id,
      value: time.name,
      label: time.name,
    };
  });

  // ✅ PREFILL currency & timezone when API + dropdown data both ready
  useEffect(() => {
    if (!currencyFromApi?.length) return;
    if (!currencyId) return;

    // ✅ Match currency by id
    const matchedCurrency = currencyFromApi.find(
      (cur) => cur.id === currencyId,
    );

    if (matchedCurrency) {
      setSelectedCurrency(matchedCurrency.country_name);
      setCountryId(matchedCurrency.country_id);
    }
  }, [currencyFromApi, currencyId]);

  useEffect(() => {
    if (!timeZoneFromApi?.length) return;
    if (!timezonedid) return;

    const matchedZone = timeZoneFromApi.find((zone) => zone.id === timezonedid);

    if (matchedZone) {
      setSelectedZone(matchedZone.name);
    }
  }, [timeZoneFromApi, timezonedid]);
 

  // 🔥 NEW: service photos (device + library)
  const [serviceImages, setServiceImages] = useState([]);

  useEffect(() => {
    return () => {
      serviceImages.forEach((img) => {
        if (img.file) {
          URL.revokeObjectURL(img.file);
        }
      });
    };
  }, [serviceImages]);

  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 8 } }),
    useSensor(TouchSensor, {
      activationConstraint: { delay: 200, tolerance: 5 },
    }),
  );

  const handleDragEnd = ({ active, over }) => {
    if (!over || active.id === over.id) return;

    setServiceImages((prev) => {
      const draggedIndex = prev.findIndex((img) => img.id === active.id);
      const overIndex = prev.findIndex((img) => img.id === over.id);

      // Make a copy of the array
      const newArr = [...prev];

      // Remove the dragged item
      const [dragged] = newArr.splice(draggedIndex, 1);

      // Insert it at the new position
      newArr.splice(overIndex, 0, dragged);

      // Ensure the first image is always marked as cover
      newArr.forEach((img, index) => {
        img.isCover = index === 0;
      });

      return newArr;
    });
  };

  const handleDeviceUpload = (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    const MAX_IMAGES = 10;
    const MAX_SIZE = 5 * 1024 * 1024; // 5MB
    const allowedExtensions = ["jpg", "jpeg", "png", "webp"];

    // 🔥 Image count validation
    if (serviceImages.length + files.length > MAX_IMAGES) {
      toast.error("Maximum 10 images allowed");
      e.target.value = "";
      return;
    }

    const validFiles = [];

    files.forEach((file) => {
      const extension = file.name.split(".").pop().toLowerCase();

      if (!allowedExtensions.includes(extension)) {
        toast.error(
          `${file.name} not supported. Only JPG, JPEG, PNG, WEBP allowed`,
        );
        return;
      }

      if (file.size > MAX_SIZE) {
        toast.error(`${file.name} exceeds 5MB limit`);
        return;
      }

      validFiles.push({
        id: crypto.randomUUID(),
        type: "upload",
        file,
        preview: URL.createObjectURL(file),
        name: file.name,
        isNew: true,
      });
    });

    if (!validFiles.length) {
      e.target.value = "";
      return;
    }

    setServiceImages((prev) => {
      const updated = [...prev, ...validFiles];

      // 🔥 clear image error if now valid
      if (updated.length > 0) {
        setFormErrors((old) => ({ ...old, images: "" }));
      }

      return updated;
    });

    e.target.value = "";
  };

  const validatePayload = () => {
    const errors = {};

    if (!serviceName?.trim()) {
      errors.serviceName = "Service name is required";
    }

    if (!serDescrip?.trim()) {
      errors.serDescrip = "Service description is required";
    }

    if (!selectedCurrency) {
      errors.currency = "Currency is required";
    }

    if (!selectedZone) {
      errors.timezone = "Timezone is required";
    }

    if (
      !lunchstart.hour ||
      !lunchstart.minute ||
      !lunchend.hour ||
      !lunchend.minute
    ) {
      errors.lunch = "Lunch serving time is required";
    }

    if (
      !dinnerstart.hour ||
      !dinnerstart.minute ||
      !dinnerend.hour ||
      !dinnerend.minute
    ) {
      errors.dinner = "Dinner serving time is required";
    }

    if (!serviceImages.length) {
      errors.images = "At least one image is required";
    }

    return errors;
  };
  const convertTo12Hour = (time24) => {
    if (!time24) return { hour: "", minute: "", period: "AM" };

    const [h, m] = time24.split(":").map(Number);
    const period = h >= 12 ? "PM" : "AM";
    const hour = h % 12 === 0 ? 12 : h % 12;

    return {
      hour: String(hour),
      minute: String(m).padStart(2, "0"),
      period,
    };
  };

  const to24Hour = ({ hour, minute, period }) => {
    let h = parseInt(hour, 10);
    if (period === "PM" && h !== 12) h += 12;
    if (period === "AM" && h === 12) h = 0;

    return `${String(h).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
  };

  const handleOnServiceSave = async () => {
    if (!validatePayload()) {
      return;
    }

    try {
      const uploadableImages = serviceImages.filter(
        (img) => img.isNew && img.type === "upload" && img.file,
      );
      const initialImages = initialImagesRef.current;

      const imagesChanged =
        removedImages.length > 0 ||
        serviceImages.some((img) => img.isNew) ||
        JSON.stringify(serviceImages.map((i) => i.imageId)) !==
          JSON.stringify(initialImages.map((i) => i.imageId));

      let uploadedNames = [];
      if (uploadableImages.length > 0) {
        const fd = new FormData();
        fd.append("type", "service_provider/other_images");
        uploadableImages.forEach((img) => fd.append("images[]", img.file));

        const uploadRes = await dispatch(otherServiceImages(fd)).unwrap();
        if (!uploadRes.success) {
          toast.error(uploadRes.message || "Image upload failed");
          return;
        }

        uploadedNames = uploadRes?.data?.temp_images || [];
        uploadableImages.forEach((img, index) => {
          img.uploadedName = uploadedNames[index];
        });
      }
      let service_cover_images = null;

      if (serviceImages.length > 0) {
        const cover = serviceImages[0];

        if (cover.type === "upload") {
          service_cover_images = {
            type: "upload",
            name: cover.isNew ? cover.uploadedName : cover.name,
          };
        }

        if (cover.type === "gallery") {
          service_cover_images = {
            type: "gallery",
            id: cover.imageId,
          };
        }
      }

      const service_other_images = serviceImages
        .slice(1)
        .filter((img) => img.isNew)
        .map((img) => {
          if (img.type === "upload") {
            return {
              type: "upload",
              name: img.uploadedName,
            };
          }

          if (img.type === "gallery") {
            return {
              type: "gallery",
              id: img.imageId,
              name: img.name || "",
            };
          }

          return null;
        })
        .filter(Boolean);

      // ✅ Removed images
      const removed_other_images = removedImages.map((img) => ({
        type: img.type,
        id: img.id,
        name: img.name,
      }));

      const payload = {
        service_name: serviceName,
        service_description: serDescrip,
        is_pure_veg_food: toggleValue,
        currency_id: currencyId,
        timezone_id: timezonedid,
        lunch_time_from: to24Hour(lunchstart),
        lunch_time_to: to24Hour(lunchend),
        dinner_time_from: to24Hour(dinnerstart),
        dinner_time_to: to24Hour(dinnerend),
        is_currency_and_timezone_enable: isCurrencyEnabled,
        service_cover_images: service_cover_images || null,
        service_other_images: service_other_images || [],
        removed_other_images: removed_other_images,
      };
      // console.log("🔥 FINAL PAYLOAD:", payload);

      const res = await dispatch(addOrUpdateService(payload)).unwrap();
      // console.log("the res is :", res.data);
      if (!res?.success) {
        toast.error(res?.message || "Service update failed");
        return;
      }
      toast.success("Service updated successfully");
      navigate("/profile");
    } catch (err) {
      const errorMessage =
        err?.data?.message ||
        err?.message ||
        err ||
        "Failed to update service Identity";
      toast.error(errorMessage);
    }
  };

  return (
    <>
      {isServiceLoading ? (
        <>
          {" "}
          <EditServiceShimmer />{" "}
        </>
      ) : (
        <>
          {" "}
          <section className="relative max-w-7xl mx-auto px-4 md:px-6 py-10">
            <DecorativeSquares />

            {/* ================= PAGE HEADER ================= */}
            <div className="sticky top-2 z-10 bg-white/80 backdrop-blur-md rounded-2xl shadow-md px-4 py-3 flex items-center justify-between mb-6">
              <button
                onClick={() => navigate("/profile")}
                className="p-2 rounded-full hover:bg-gray-100"
              >
                <FaArrowLeft size={20} />
              </button>

              <h1 className="text-xl md:text-2xl font-semibold text-gray-900">
                Service Details
              </h1>

              <div className="w-10" />
            </div>

            {/* ================= MAIN FORM CARD ================= */}
            <div className="bg-white rounded-3xl shadow-sm border px-6 sm:px-8 py-8 max-w-6xl mx-auto space-y-10">
              {/* ================= SERVICE NAME ================= */}
              <div className=" mx-auto">
                <TextInput
                  label="Tiffin service name"
                  required={true}
                  name="servicename"
                  value={serviceName}
                  onChange={(e) => setServiceName(e.target.value)}
                  placeholder="Enter Tiffin Service Name"
                />
                {formErrors.serviceName && (
                  <p className="text-red-500 text-xs mt-1">
                    {formErrors.serviceName}
                  </p>
                )}
              </div>

              {/* ================= UPLOAD HEADING ================= */}
              <div className="flex items-center gap-2  mx-auto">
                <p className="text-sm sm:text-base font-medium">
                  Upload tiffin service photographs
                </p>

                <CiCircleInfo
                  size={18}
                  className="cursor-pointer text-gray-500"
                  data-tooltip-id="photo-info"
                  data-tooltip-content="Upload photo of your best dishes"
                />

                <Tooltip
                  id="photo-info"
                  place="top"
                  className="!text-xs !bg-black !px-3 !py-2 !rounded-lg !max-w-[220px] text-center"
                />
              </div>

              {/* ================= UPLOAD CARD ================= */}
              <div className=" mx-auto">
                <UploadTriggerCard
                  icon={uploadIcon}
                  required={true}
                  text="Upload your service logo or brand photo"
                  buttonText="Upload"
                  onClick={() => setShowUploadOptions(true)}
                />
                {formErrors.images && (
                  <p className="text-red-500 text-xs mt-1">
                    {formErrors.images}
                  </p>
                )}
              </div>

              <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                multiple
                className="hidden"
                onChange={handleDeviceUpload}
              />

              {/* ================= IMAGE PREVIEW ================= */}
              {serviceImages.length > 0 && (
                <div className="max-w-5xl mx-auto">
                  <DndContext
                    sensors={sensors}
                    collisionDetection={closestCenter}
                    onDragEnd={handleDragEnd}
                  >
                    <SortableContext
                      items={serviceImages.map((i) => i.id)}
                      strategy={rectSortingStrategy}
                    >
                      <div className="grid grid-cols-4 sm:grid-cols-5 md:grid-cols-6 xl:grid-cols-8 gap-4 touch-none">
                        {serviceImages.map((item, i) => (
                          <SortableImageItem
                            key={item.id} // ✅ stable key
                            id={item.id}
                            img={item} // ✅ pass full object
                            isCover={i === 0}
                            onRemove={() => {
                              setServiceImages((prev) => {
                                const removed = prev.find(
                                  (img) => img.id === item.id,
                                );
                                if (!removed) return prev;

                                if (!removed.isNew) {
                                  setRemovedImages((old) => {
                                    if (
                                      old.some(
                                        (img) => img.id === removed.imageId,
                                      )
                                    )
                                      return old;

                                    return [
                                      ...old,
                                      {
                                        type: removed.type,
                                        id: removed.imageId,
                                        name: removed.name || "",
                                      },
                                    ];
                                  });
                                }

                                return prev.filter((img) => img.id !== item.id);
                              });
                            }}
                          />
                        ))}
                      </div>
                    </SortableContext>
                  </DndContext>

                  <p className="mt-3 text-sm text-gray-600">
                    Note: The first image will appear as your cover image.You
                    can click and hold to drag images and change their order.
                  </p>
                </div>
              )}

              {/* ================= DETAILS ================= */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto">
                {/* Description */}
                <div className="md:col-span-2">
                  <div className="flex gap-2 items-center mb-1">
                    <p>Description</p>
                    <CiCircleInfo
                      size={18}
                      className="cursor-pointer text-gray-500"
                      data-tooltip-id="desc-info"
                      data-tooltip-content="Add a short description about your tiffin - plans, offers, quality etc"
                    />
                    <Tooltip
                      id="desc-info"
                      place="top"
                      className="!text-xs !bg-black !px-3 !py-2 !rounded-lg !max-w-[240px] text-center"
                    />
                  </div>
                  <TextInput
                    name="description"
                    placeholder="Enter Description"
                    value={serDescrip}
                    onChange={(e) => setSerDescrip(e.target.value)}
                    required
                  />
                  {formErrors.serDescrip && (
                    <p className="text-red-500 text-xs mt-1">
                      {formErrors.serDescrip}
                    </p>
                  )}
                </div>

                {/* Veg Toggle */}
                <div className="flex items-center justify-between border rounded-lg px-4 py-3 md:col-span-2">
                  <p className="text-[#191919] text-sm sm:text-base">
                    We offer pure vegetarian food.
                  </p>
                  <ToggleBtn
                    isOn={toggleValue === 1}
                    size={40}
                    onChange={(val) => setToggleValue(val ? 1 : 0)}
                  />
                </div>

                {/* Currency & Timezone */}
                <div>
                  <Select
                    label="Currency"
                    name="currency"
                    required={true}
                    value={selectedCurrency}
                    onChange={(selectedValue) => {
                      setSelectedCurrency(selectedValue);

                      const selectedCurrencyObj = currencies.find(
                        (c) => String(c.value) === String(selectedValue),
                      );

                      if (selectedCurrencyObj) {
                        setCurrencyId(selectedCurrencyObj.id);

                        const countryIdFromCurrency = currencyFromApi.find(
                          (cur) => cur.id === selectedCurrencyObj.id,
                        )?.country_id;

                        if (countryIdFromCurrency) {
                          setCountryId(countryIdFromCurrency);
                        }
                      }
                    }}
                    disabled={isCurrencyEnabled === 0}
                    options={currencies}
                    displaySelected="label"
                  />
                  {formErrors.currency && (
                    <p className="text-red-500 text-xs mt-1">
                      {formErrors.currency}
                    </p>
                  )}
                </div>
                <div>
                  <Select
                    label="Timezone"
                    name="Timezone"
                    required={true}
                    value={selectedZone}
                    disabled={isCurrencyEnabled === 0}
                    onChange={(selectedValue) => {
                      setSelectedZone(selectedValue);

                      const selectedZoneObj = timezones.find(
                        (tz) => String(tz.value) === String(selectedValue),
                      );

                      if (selectedZoneObj) {
                        setTimezoneid(selectedZoneObj.id);
                      }
                    }}
                    options={timezones}
                  />
                  {formErrors.timezone && (
                    <p className="text-red-500 text-xs mt-1">
                      {formErrors.timezone}
                    </p>
                  )}
                </div>
                {/* Time Pickers */}
                <div>
                  <TimeRangePicker12
                    label="Lunch Serving Time"
                    startTime={lunchstart}
                    endTime={lunchend}
                    onStartChange={setLunchStart}
                    onEndChange={setLunchEnd}
                  />
                  {formErrors.lunch && (
                    <p className="text-red-500 text-xs mt-1">
                      {formErrors.lunch}
                    </p>
                  )}
                </div>

                <div>
                  <TimeRangePicker12
                    label="Dinner Serving Time"
                    startTime={dinnerstart}
                    endTime={dinnerend}
                    onStartChange={setDinnerStart}
                    onEndChange={setDinnerEnd}
                  />
                  {formErrors.dinner && (
                    <p className="text-red-500 text-xs mt-1">
                      {formErrors.dinner}
                    </p>
                  )}
                </div>
              </div>
              <div>
                <PrimaryBtn
                  btnName="Save"
                  clickEvent={handleOnServiceSave}
                  isLoading={isServiceLoading}
                />
              </div>
            </div>

            {/* ================= UPLOAD MODAL ================= */}
            {showUploadOptions && (
              <div className="fixed inset-0 bg-[#0F172A]/60 flex items-center justify-center z-50 animate-fadeIn">
                <div className="relative w-full max-w-lg mx-4">
                  {/* Modal Card */}
                  <div className="relative bg-white rounded-3xl p-8 shadow-[0_25px_60px_-15px_rgba(0,0,0,0.25)] border border-gray-100">
                    {/* Accent Top Bar */}

                    {/* Title Section */}
                    <div className="text-center mb-8">
                      <h2 className="text-2xl font-semibold text-gray-900 tracking-tight">
                        Upload Photos
                      </h2>
                      <p className="text-sm text-gray-500 mt-1">
                        Choose how you want to add your images
                      </p>
                    </div>

                    {/* Options */}
                    <div className="space-y-4">
                      {/* Upload From Device */}
                      <button
                        onClick={() => {
                          setShowUploadOptions(false);
                          fileInputRef.current.click();
                        }}
                        className="group relative w-full flex items-center justify-between px-6 py-5 rounded-2xl 
                     bg-gradient-to-r from-[#FF7043]/20 to-[#FF5722]/50 
                     text-white font-medium shadow-lg 
                     "
                      >
                        <div className="flex items-center gap-4">
                          <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-white/20">
                            <img
                              src={UploadIcon}
                              alt="uploadIcon"
                              className="w-6 h-6"
                            />
                          </div>
                          <span className="text-base text-black">
                            Upload from device
                          </span>
                        </div>

                        <span className="opacity-70 group-hover:translate-x-1 transition-transform duration-300">
                          →
                        </span>
                      </button>

                      {/* Choose From Library */}
                      <button
                        onClick={() => {
                          setShowUploadOptions(false);
                          setShowLibrary(true);
                        }}
                        className="group w-full flex items-center justify-between px-6 py-5 rounded-2xl 
                     border border-gray-200 bg-white 
                     text-gray-700 font-medium 
                     "
                      >
                        <div className="flex items-center gap-4">
                          <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gray-100">
                            <img
                              src={GalleryImg}
                              alt="galleryicon"
                              className="w-6 h-6"
                            />
                          </div>
                          <span className="text-base">
                            Choose from photo library
                          </span>
                        </div>

                        <span className="text-gray-400 group-hover:translate-x-1 transition-transform duration-300">
                          →
                        </span>
                      </button>
                    </div>

                    {/* Footer */}
                    <div className="mt-8 text-center">
                      <button
                        onClick={() => setShowUploadOptions(false)}
                        className="text-sm text-gray-400 hover:text-gray-600 transition-colors duration-200"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </section>
        </>
      )}

      {/* ================= PHOTO LIBRARY ================= */}
      {showLibrary && (
        <PhotoLibraryModal
          selectedImages={serviceImages
            .filter((img) => img.type === "gallery")
            .map((img) => img.imageId)}
          onClose={() => setShowLibrary(false)}
          onToggleSelect={(photo) => {
            setServiceImages((prev) => {
              const MAX_IMAGES = 10;
              const alreadyExists = prev.find(
                (img) => img.type === "gallery" && img.imageId === photo.id,
              );

              // 🔥 Max limit check
              if (prev.length >= MAX_IMAGES) {
                toast.error("Maximum 10 images allowed");
                return prev;
              }
              // 🔥 If already selected → REMOVE (deselect)
              if (alreadyExists) {
                // also track removed images if needed
                if (!alreadyExists.isNew) {
                  setRemovedImages((old) => [
                    ...old,
                    {
                      type: "gallery",
                      id: alreadyExists.imageId,
                      name: alreadyExists.name,
                    },
                  ]);
                }

                return prev.filter((img) => img.imageId !== photo.id);
              }

              // 🔥 If not selected → ADD
              return [
                ...prev,
                {
                  id: crypto.randomUUID(),
                  type: "gallery",
                  preview: photo.image,
                  imageId: photo.id,
                  name: photo.image.split("/").pop(),
                  isNew: true,
                },
              ];
            });
          }}
        />
      )}
    </>
  );
};

export default EditService;
